export default "__VITE_ASSET__CymaAmJF__"